import { Link } from "react-router-dom";
import { ArrowRight, Building2, Lightbulb, PencilLine, Send, TrendingUp } from "lucide-react";
import { PageHero, Reveal } from "@/components/site/Section";
import { STEPS, IMG } from "@/data/content";

const ICONS = [Building2, Lightbulb, PencilLine, Send, TrendingUp];
const COLORS = ["#4f46e5", "#7c3aed", "#db2777", "#06b6d4", "#10b981"];

export default function HowItWorks() {
  return (
    <div data-testid="how-page">
      <PageHero eyebrow="How it works" title={<>From Business Goals to <span className="text-gradient">Organized Marketing</span></>}
        copy="A simple, human-in-the-loop workflow designed for non-technical SMB teams." img={IMG.office} />
      <section className="py-20 md:py-28">
        <div className="container-x relative">
          <div className="absolute left-[39px] md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-[#4f46e5] via-[#db2777] to-[#10b981] opacity-40" />
          <div className="space-y-12">
            {STEPS.map((s, i) => {
              const I = ICONS[i];
              return (
                <Reveal key={s.t}>
                  <div className={`relative grid md:grid-cols-2 gap-8 items-center ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`}>
                    <div className={`pl-24 md:pl-0 ${i % 2 ? "md:pl-16" : "md:pr-16 md:text-right"}`}>
                      <div className="font-mono text-xs" style={{ color: COLORS[i] }}>STEP 0{i + 1}</div>
                      <h2 className="mt-2 text-2xl sm:text-3xl font-bold">{s.t}</h2>
                      <p className="mt-3 text-muted-foreground leading-relaxed">{s.d}</p>
                    </div>
                    <div className="hidden md:block" />
                    <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 top-0 h-20 w-20 rounded-2xl border bg-card flex items-center justify-center shadow-xl" style={{ color: COLORS[i] }}>
                      <I className="h-8 w-8" />
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
          <div className="mt-20 flex flex-wrap gap-3">
            <Link to="/tour" className="btn-brand" data-testid="how-tour-btn">Launch Interactive Demo <ArrowRight className="h-4 w-4" /></Link>
            <Link to="/register" className="btn-ghost">Create a Free Account</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
